<script setup>
import { computed } from "@vue/reactivity";
import { payTypeListInfo } from "./data";
import { payEnum } from './enum'
import { getClassPayInfo } from 'model/money'
import { onMounted, defineProps, defineEmits, ref, toRefs } from "vue";
import { reactive } from "vue";
import { watch } from "vue";

const $props = defineProps({
  state: {
    type: Object,
    default: () => ({
      list: []
    })
  },
  valid: {
    type: Boolean,
    default: false
  },
  promoCode: {
    type: [Object, String],
    default: ''
  },
  reward: {
    type: [Object, String],
    default: ''
  },
  addedPromoCode: {
    type: Object,
    default: () => { }
  },
  useList: {
    type: [Object, Array],
    default: () => []
  },
  unUseList: {
    type: [Object, Array],
    default: () => []
  },
})
// const props = computed(() => {
//   return $props
// })
const { state, valid, promoCode, reward, addedPromoCode, useList, unUseList } = toRefs($props)
const emits = defineEmits(['openAction', 'payTypeChange', 'handleClickPayType'])

const activeName = ref(payEnum[0].value)
const payClassControl = reactive({})

// 获取支付方式的信息
const f_PayList = computed(() => {
  const v = state.value.list
  //!!! 暂时无法达到 400 个支付方式， 所以400长度的数组
  const arr = new Array(400)
  for (let i = 0; i < v.length; i++) {
    arr[v[i].id] = v[i]?.payType
  }
  return arr
})
// 接口支付信息
const f_BackPayTypeInfo = computed(() => {
  const obj = {}
  const v = state.value.list
  v.forEach((item) => {
    obj[item.payType] = item
  })
  return obj
})
// 支付信息
const f_PayTypeInfo = computed(() => {
  const obj = {}
  payTypeListInfo.forEach((item) => {
    obj[item.type] = item
  })
  return obj
})
const f_PayEnum = computed(() => {
  const obj = {}
  payEnum.forEach((item) => {
    obj[item.value] = item
  })
  return obj
})
const f_PayClassControl = computed(() => {
  let arr = []
  for (let i in payClassControl) {
    if (payClassControl[i].length > 0) {
      arr.push(
        {
          name: i,
          value: payClassControl[i]
        }
      )
    } 
  }
  return arr
})
const initClasPay = (v = false) => {
  payEnum.forEach((e) => {
    if (!v || !v[e.value]) {
      payClassControl[e.value] = []
    }
    payClassControl[e.value] = v[e.value]
  })
}
const getClassPay = async () => {
  const res = await getClassPayInfo()
  if (res) {
    initClasPay(res)
  } else {
    initClasPay()
  }
}
watch(
  () => activeName.value,
  (nv) => {
    emits('handleClickPayType', f_BackPayTypeInfo.value[f_PayList.value[payClassControl[nv][0]]])
    emits('payTypeChange')
  }
)

onMounted(() => {
  getClassPay()
})

</script>
<template>
  <div>
    <!-- 支付列表 -->
    <!-- {{ state.list }} -->
    <van-tabs v-model:active="activeName" class="reset-tabs" shrink>
      <div>
        <van-tab v-for="it in f_PayClassControl" :key="it.name" :name="it.name">
          <template #title>
            <span class="tab-title">
              <img :src="activeName === it.name ? f_PayEnum[it.name]?.act_img : f_PayEnum[it.name]?.img" alt="">
              <span class="ml-5">{{ f_PayEnum[it.name]?.label }}</span>
            </span>
          </template>

          <div
            class="radio-group flex flex-direction"
            v-for="item in payClassControl[activeName]"
            :key="item"
            @click="emits('payTypeChange')"
          >
            <div v-if="f_BackPayTypeInfo[f_PayList[item]]" @click="emits('handleClickPayType', f_BackPayTypeInfo[f_PayList[item]])">
              <div class="radio-group-content flex justify-between">
                <div class="radio-group_title flex align-center">
                  <img
                    class="icon-image"
                    :class="f_PayList[item]"
                    :src="f_PayTypeInfo[f_PayList[item]]?.img"
                    :alt="f_PayTypeInfo[f_PayList[item]]?.payType"
                  >
                  <span class="custom-title ml-10" style="font-weight: bold">{{
                    f_PayTypeInfo[f_PayList[item]]?.name
                  }}</span>
                </div>
                <van-radio name="1" :checked="state.selectPay === f_PayList[item]" label-disabled />
              </div>
              <div class="radio-group-sheet" v-show="state.selectPay === f_PayList[item]">
                <span class="bonus-text" v-if="valid && promoCode">+<span
                  style="color: #00c800; font-weight: bold"
                >$ {{
                  reward }}</span>Bonus</span>
                <span class="bonus-text" v-else>No Used</span>
                <!-- <span style="color:red" class="error-message">{{ rechargeForm.validType!=='click'?promoCodeMessage:'' }}</span> -->
                <van-icon name="passed" color="#4fc08d" v-show="addedPromoCode && valid" />&nbsp;<a
                  href="javascript:;"
                  @click="emits('openAction')"
                >
                  <!-- {{ rechargeForm.promoCode ? useList.length-1 : useList.length }} availabel -->
                  Total {{ useList.length + unUseList.length }}
                </a>
              </div>
            </div>
          </div>
        </van-tab>
      </div>
    </van-tabs>
  </div>
</template>
<style lang="scss" scoped>
.tab-title {
    img {
        vertical-align: text-top;
    }
}

.reset-tabs {
    ::v-deep .van-tab--active {
        color: #fff;
        background: linear-gradient(1deg, #6153FF 0%, rgba(97, 83, 255, 0.8) 100%) !important;
    }
    ::v-deep .van-tabs__line {
        display: none;
    }
}

.radio-group {
    padding-left: 10px;
    border-bottom: 1px solid #ebeef5;

    .radio-group_title {
        width: 80%;
    }

    .radio-group-content {
        position: relative;
        padding: 0 10px;
        height: 50px;
        line-height: 20px;

        .van-radio {
            position: absolute;
            right: 10px;
            top: 50%;
            margin-top: -10px;
        }
    }

    .radio-group-sheet {
        padding: 10px;
        background: #f9f9f9;
        text-align: right;

        a {
            text-decoration: underline;
        }
    }
}
span.custom-title {
  font-size: 13px;
}
</style>